<div class="wrapper-slider">
  <unh-generic-swiper-slider
    *ngIf="slides.length > 0"
    [items]="slides"
    [isMobile]="true"
    [swiperConfigs]="config"
  >
    <ng-template #genericSwiperItemTemplate let-item>
      <unh-video-box
        [url]="item.thumbnail"
        [title]="item.title"
        [instrutor]="item.instructor"
        [link]="item.link"
        [totaltime]="item.totaltime"
        [free]="free"
      ></unh-video-box>
    </ng-template>
  </unh-generic-swiper-slider>

  <unh-generic-swiper-slider
    *ngIf="slides.length === 0"
    [items]="slidesLoading"
    [isMobile]="true"
    [swiperConfigs]="configloading"
  >
    <ng-template #genericSwiperItemTemplate let-item>
      <unh-video-box
        [loading]="true"
      ></unh-video-box>
    </ng-template>
  </unh-generic-swiper-slider>
</div>

